import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis,
  YAxis,
 } from "recharts";
// import "./barChartBox.scss";

type Props = {
  title: string;
  color: string;
  dataKey: string;
  chartData: object[];
};

const BarChartBox = (props: Props) => {
  return (
    <div className="w-full h-full ">
      <h1 className="text-xl mb-5">{props.title}</h1>
      <div className="">
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={props.chartData}>
          <XAxis dataKey="name" tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#75b4db' }}
              axisLine={{ stroke: '#EAF0F4' }}
              style={{
                fontSize: '14px',
                // fontFamily: 'Times New Roman',
              }}
            />
            <YAxis tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#75b4db' }}
              axisLine={{ stroke: '#EAF0F4' }} 
              style={{
                fontSize: '14px',
                // fontFamily: 'Times New Roman',
              }}
            />
            <Tooltip
              contentStyle={{ background: "#2a3447", borderRadius: "5px" }}
              labelStyle={{ display: "none" }}
              cursor={{fill:"none"}}
            />
            <Bar dataKey={props.dataKey} fill={props.color} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BarChartBox;
